// StatsCounter.jsx
import React, { useState, useEffect } from "react";

const StatsCounter = () => {
  const stats = {
    courses: 50,
    institutes: 1000,
    locations: 100,
    rating: 4.8,
  };

  const [courseCount, setCourseCount] = useState(0);
  const [instituteCount, setInstituteCount] = useState(0);
  const [locationCount, setLocationCount] = useState(0);
  const [rating, setRating] = useState(0);

  const animateCount = (setter, finalValue, duration = 1000, isFloat = false) => {
    let startTime;

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percentage = Math.min(progress / duration, 1);
      const current = finalValue * percentage;

      setter(isFloat ? parseFloat(current.toFixed(1)) : Math.round(current));

      if (percentage < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  };

  useEffect(() => {
    animateCount(setCourseCount, stats.courses);
    animateCount(setInstituteCount, stats.institutes);
    animateCount(setLocationCount, stats.locations);
    animateCount(setRating, stats.rating, 1000, true);
  }, []);

  return (
    <div className="w-full max-w-2xl mt-8 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-2 px-2">
      <div className="bg-white rounded-lg py-1 px-1 text-center">
        <div className="text-base md:text-lg font-bold text-neutral-900">{courseCount}+</div>
        <div className="text-neutral-600 text-xs">Adventure Courses</div>
      </div>
      <div className="bg-white rounded-lg py-1 px-1 text-center">
        <div className="text-base md:text-lg font-bold text-neutral-900">{instituteCount}+</div>
        <div className="text-neutral-600 text-xs">Institutes</div>
      </div>
      <div className="bg-white rounded-lg py-1 px-1 text-center">
        <div className="text-base md:text-lg font-bold text-neutral-900">{locationCount}+</div>
        <div className="text-neutral-600 text-xs">Locations Worldwide</div>
      </div>
      <div className="bg-white rounded-lg py-1 px-1 text-center">
        <div className="text-base md:text-lg font-bold text-neutral-900">{rating.toFixed(1)}</div>
        <div className="text-neutral-600 text-xs">Average Rating</div>
      </div>
    </div>
  );
};

export default StatsCounter;
